import React, { useEffect, useRef, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { useReveal } from "../hooks/useReveal";

// Real client testimonials
const testimonials = [
  {
    id: 1,
    name: "Pani Agnieszka",
    role: "Kwit Kosmetologia",
    poster:
      "https://customer-assets.emergentagent.com/job_premium-web-build-13/artifacts/md4vbk2y_kwit%20kosmetologia.png",
    video:
      "https://customer-assets.emergentagent.com/job_premium-web-build-13/artifacts/lo6b8zwu_opinia%20kwitkosmetologia.mp4",
  },
  {
    id: 2,
    name: "Pani Liliana",
    role: "Trycholog Szczecinek",
    poster:
      "https://customer-assets.emergentagent.com/job_premium-web-build-13/artifacts/xzolvh6w_trycholog%20szczecinek.png",
    video:
      "https://customer-assets.emergentagent.com/job_premium-web-build-13/artifacts/xv3tukoe_opinia%20trychologszczecinekpl.mp4",
  },
  {
    id: 3,
    name: "Pan Zbyszek",
    role: "Pluta Motors",
    poster: null,
    video:
      "https://customer-assets.emergentagent.com/job_premium-web-build-13/artifacts/k9xbhyiu_opinia-pluta-motors-1.mp4",
  },
  {
    id: 4,
    name: "Pan Damian",
    role: "My Car Spa",
    poster:
      "https://customer-assets.emergentagent.com/job_premium-web-build-13/artifacts/87pa2886_my%20car%20spa%20autokosmetyka.png",
    video:
      "https://customer-assets.emergentagent.com/job_premium-web-build-13/artifacts/sbu7wd4e_opinia-my-car-spa.mp4",
  },
];

const VideoCard = ({ t, idx }) => {
  const ref = useRef(null);
  const [muted, setMuted] = useState(true);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            el.play().catch(() => {});
          } else {
            el.pause();
          }
        });
      },
      { threshold: 0.4 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  const toggleMute = (e) => {
    e.stopPropagation();
    if (!ref.current) return;
    ref.current.muted = !ref.current.muted;
    setMuted(ref.current.muted);
  };

  return (
    <div
      data-testid={`testimonial-card-${idx}`}
      className={`reveal reveal-delay-${(idx % 4) + 1} group relative aspect-[9/16] rounded-3xl overflow-hidden border border-white/10 hover:border-stormly-cyan/40 transition-all duration-500 bg-[#15152b]`}
    >
      <video
        ref={ref}
        src={t.video}
        poster={t.poster || undefined}
        muted={muted}
        loop
        playsInline
        preload="metadata"
        className="absolute inset-0 w-full h-full object-cover"
      />

      <div className="absolute inset-0 bg-gradient-to-t from-[#1A1A2E] via-[#1A1A2E]/10 to-transparent pointer-events-none" />

      <button
        type="button"
        onClick={toggleMute}
        aria-label={muted ? "Włącz dźwięk" : "Wycisz"}
        data-testid={`testimonial-mute-${idx}`}
        className="absolute top-4 right-4 h-10 w-10 rounded-full bg-black/40 backdrop-blur-md border border-white/15 text-white flex items-center justify-center hover:bg-stormly-cyan/20 hover:border-stormly-cyan/50 transition-colors z-10"
      >
        {muted ? <VolumeX size={16} /> : <Volume2 size={16} />}
      </button>

      <div className="absolute bottom-0 left-0 right-0 p-5 z-10">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-white font-heading font-bold text-base">
              {t.name}
            </p>
            <p className="text-white/70 text-xs">{t.role}</p>
          </div>
          <span className="pulse-dot" />
        </div>
      </div>
    </div>
  );
};

export const VideoTestimonials = () => {
  const ref = useReveal();
  return (
    <section
      id="opinie"
      ref={ref}
      data-testid="testimonials-section"
      className="relative py-24 md:py-32 px-6 md:px-10"
    >
      <div className="max-w-7xl mx-auto">
        <div className="reveal text-center max-w-3xl mx-auto mb-14">
          <span className="text-xs tracking-[0.2em] uppercase text-stormly-cyan font-bold">
            Opinie · Wideo
          </span>
          <h2 className="font-heading font-bold text-4xl sm:text-5xl md:text-6xl mt-4 leading-[1.05]">
            Posłuchaj{" "}
            <span className="text-white/50">tych, którzy już rozświetlili</span>{" "}
            swoją markę.
          </h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {testimonials.map((t, i) => (
            <VideoCard key={t.id} t={t} idx={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
